/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "1",
    title: "launching neog.camp: roadmap to full stack dev",
    description:
      "neog.camp is one of its kind bootcamp where we are taking absolute beginners and getting them to a full stack web dev level in 6 months.In this session, I will be walking you through the structure of the camp. And will take questions from the live chat. If you already know about the camp, you can skip this session and save your time. Details of the camp can be found on https://neog.camp",
    creator: "Tanay Pratap",
    link: "https://www.youtube.com/embed/Ezk2AwqgS9Q",
    pic: "https://i.ytimg.com/vi/Ezk2AwqgS9Q/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLA1VisFh6_Uurec8nadJS6rc2Mdyw",
  },
  {
    _id: "2",
    title: "HOW to write your First CLI App: Intro to programming | Tanay Pratap",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's first class. This is the most basic class you'll find on programming. We will use JavaScript to code. Using nodeJS we will write a CLI (Command Line Interface) program. We'll then use https://repl.it to host it. ",
    link: "https://www.youtube.com/embed/_L-UszPmy2A",
    pic: "https://i.ytimg.com/vi/_L-UszPmy2A/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLC4-OXdTPpZdf3llkLcLVEjzl-bGg",
  },
  {
    _id: "3",
    title: "Getting started with Git, VSCode and Hosting",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's second class. For a newbie to self host his/her first website and program more apps we need some tooling to be in place. Tools help you make your life easier. All these tools are free for you and will give you a better place to code, a place to store your code in the cloud so that you don't lose it, and then a place to host your app so that others can find it. ",
    link: "https://www.youtube.com/embed/MMEIVh49pS8",
    pic: "https://i.ytimg.com/vi/MMEIVh49pS8/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLCgITDTeBCwKkr2CW3zt-bt3P5uSA",
  },
  {
    _id: "4",
    title: "Getting started with HTML5",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero journey. You don't know anything about web development? Good, you have come to the right place. Not only you'll learn the language of the web: HTML, you'll learn how to make your site pretty with CSS. When we have learned everything we will put together a decent profile to host your Internet adventures. ",
    link: "https://www.youtube.com/embed/No8qdcVYiQw",
    pic: "	https://i.ytimg.com/vi/No8qdcVYiQw/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLB5Y0QC8VlGkKbJ6fjwnhOPrdkLyw",
  },
  {
    _id: "5",
    title: "Getting started with CSS3",
    creator: "Tanay Pratap",
    description:
      "Tentative Duration: 2 hours. Back after break from first session of today. This time we will do CSS. Welcome to neogcamp levelZero journey. You do not know anything about web development? Good, you have come to the right place. Not only you will learn the language of the web: HTML, you will learn how to make your site pretty with CSS. When we have learned everything we will put together a decent profile to host your Internet adventures.",
    link: "https://www.youtube.com/embed/u6_a0d94A1Q",
    pic: "https://i.ytimg.com/vi/u6_a0d94A1Q/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLCFbCbuzqAtwJwTRe63CQW8GAmlsw",
  },
  {
    _id: "6",
    title: "JavaScript in the browser!",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp. We have learned programming and web basics in previous lessons. This time we will use both things to create a dynamic app in a web browser. You'll learn about DOM scripting i.e. JS in the browser, calling servers, and getting data from there, taking user input and showing user output, and many more things.",
    link: "https://www.youtube.com/embed/yLZazznWoAs",
    pic: "https://i.ytimg.com/vi/yLZazznWoAs/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLDEXYMLowXfqVUeYVrT-OJqQDUJUA",
  },
  {
    _id: "7",
    title: "First React App: Introduction to ReactJS library",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp. We have learned programming, web basics and vanillaJS in previous lessons. Now we use ReactJS, the most in-demand JS library today to create a dynamic app in the browser. We will be looking at the basics of React, JSX, useState, onClick handler, etc. ",
    link: "https://www.youtube.com/embed/KUJsaM-hAjs",
    pic: "https://i.ytimg.com/vi/KUJsaM-hAjs/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLCi-nZ8gs-FgCg4jsjAgmiWNZwyiA",
  },
  {
    _id: "8",
    title: "mark10: Build your cash register with vanillaJS",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero live pair programming session.",
    link: "https://www.youtube.com/embed/oqpuG3-Pnvc",
    pic: "https://i.ytimg.com/vi/oqpuG3-Pnvc/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLAwJ1XnR8GkclWIqJahuvPOCXpviQ",
  },
  {
    _id: "9",
    title: "Mark11: Is your birthday lucky?",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero live pair programming session.",
    link: "https://www.youtube.com/embed/KKodpTaLHUI",
    pic: "https://i.ytimg.com/vi/KKodpTaLHUI/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLBdpH1oUQi_ySNcwSvEXhqNf-__SA",
  },
  {
    _id: "10",
    title: "mark12: Fun with Triangles",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero live pair programming session.",
    link: "https://www.youtube.com/embed/xOaKv-6bJwE",
    pic: "https://i.ytimg.com/vi/xOaKv-6bJwE/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLCIVU6eLN1zGpKgyazvT31V5mDDcg",
  },
  {
    _id: "11",
    title: "mark13: Is your birthday a palindrome?",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero live pair programming session.",
    link: "https://www.youtube.com/embed/8rqZ524NzaQ",
    pic: "	https://i.ytimg.com/vi/8rqZ524NzaQ/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLCDTPZ8ZUlZhBYDeTccRnl3SE0dwA",
  },
  {
    _id: "12",
    title: "mark 14: stock purchase profit or loss",
    creator: "Tanay Pratap",
    description:
      "Welcome to neogcamp's levelZero live pair programming session. ",
    link: "https://www.youtube.com/embed/P0dL7sl5jIc",
    pic: "https://i.ytimg.com/vi/P0dL7sl5jIc/hqdefault.jpg?s…j0AgKJDeAE=&rs=AOn4CLBptugyJlvptjzl-xDyk9jF-aBKAA",
  },
];
